import React, {Component} from 'react';
import Card from 'common/card/Card';
import IconFirstPlaceRibbon from '@spothero/icons/first-place-ribbon';
import TextButton from '@spothero/ui/text-button';
import StarRating from 'common/star-rating/StarRating';
import AppStoreUtils from 'utils/app-store';

const CONTENT = [
    {
        stars: 5,
        comment:
            "I've only used it once so far on the recommendation of friends and it worked great. Price was very reasonable and instructions easy to follow. Will definitely use again.",
        username: 'Susan Schilling',
        date: '11/11/2019',
    },
    {
        stars: 5,
        comment:
            'Parking is always available once reserved. SpotHero also posts instructions for each individual reservation in case we need to print out a copy or we’re going to be scanning in. Cost is cheap and parking spots are available almost everywhere.',
        username: 'shahrim123',
        date: '11/04/2019',
    },
    {
        stars: 5,
        comment:
            'Great parking spots and best of all they beat regular pricing.',
        username: 'Catalina Hughes',
        date: '11/08/2019',
    },
];

export default class TrustedByUsers extends Component {
    _onAppStoreButtonClicked = () => {
        AppStoreUtils.appStoreLinkClicked({
            device: 'ios',
            channel: 'prepurchase',
        });
    };

    _onPlayStoreButtonClicked = () => {
        AppStoreUtils.appStoreLinkClicked({
            device: 'android',
            channel: 'prepurchase',
        });
    };

    render() {
        return (
            <Card className="TrustedByUsers">
                <div className="TrustedByUsers-heading">
                    <IconFirstPlaceRibbon className="TrustedByUsers-heading-icon" />
                    <h2 className="TrustedByUsers-title">
                        5 Million Customers Trust SpotHero
                    </h2>
                    <div className="TrustedByUsers-app-store">
                        App Store:
                        <StarRating stars={5} />
                        <span className="ratings-reviews">4.9, (33K)</span>
                    </div>
                </div>
                <div className="TrustedByUsers-content">
                    <ul className="TrustedByUsers-reviews">
                        {CONTENT.map((item, index) => {
                            return (
                                <li
                                    key={index}
                                    className="TrustedByUsers-review"
                                >
                                    <StarRating stars={item.stars} />
                                    <p className="review-comment">
                                        {item.comment}
                                    </p>
                                    <small className="review-user-date">
                                        {item.username}, {item.date}
                                    </small>
                                </li>
                            );
                        })}
                    </ul>
                    <div className="TrustedByUsers-download-buttons">
                        <TextButton
                            className="TrustedByUsers-download-ios"
                            onClick={this._onAppStoreButtonClicked}
                        >
                            App Store Download
                        </TextButton>
                        <TextButton
                            className="TrustedByUsers-download-android"
                            onClick={this._onPlayStoreButtonClicked}
                        >
                            Google Play Download
                        </TextButton>
                    </div>
                </div>
            </Card>
        );
    }
}
